import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import get from 'lodash/get';
import { SimpleLoadingComponent } from '../../utils/apollo';
import DiversitySettings from './diversity-settings';
import updateAMEthnicDiversities from './update-diversities-mutation';

export const query = gql`
  query AMSubscriptions {
    viewer {
      id
      heAccount {
        id
        activeMatchSubscriptionDefaults {
          id
          version
          ethnicDiversities
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  props: (props) => {
    const defaults = get(props, 'data.viewer.heAccount.activeMatchSubscriptionDefaults', {});
    return {
      ...props,
      version: get(defaults, 'version', null),
      ethnicDiversities: get(defaults, 'ethnicDiversities') || [],
    };
  },
});

const updateAMEthnicDiversitiesMutation = graphql(updateAMEthnicDiversities, {
  name: 'updateAMEthnicDiversities',
  options: {
    refetchQueries: [{ query }],
    awaitRefetchQueries: true,
  },
});

export default SimpleLoadingComponent(graphqlData, updateAMEthnicDiversitiesMutation)(DiversitySettings);
